import { Component, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MediaComponent } from '@spartacus/storefront';
import { take } from 'rxjs';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
import { CurrentBusinessType } from 'src/app/utility/current-businesstype';
import { ShimanoUtilMethod } from 'src/app/utility/methods.util';
import { RemoveImageTitleAttrDirective } from '../../../../shared/remove-title-attr.directive';

@Component({
  selector: 'app-product-image-modal',
  templateUrl: './product-image-modal.component.html',
  styleUrls: ['./product-image-modal.component.scss'],
  imports: [MatIcon, MediaComponent, RemoveImageTitleAttrDirective],
})
export class ProductImageModalComponent implements OnInit {
  modalData: any;
  businessType: string;

  constructor(private modalService: StandardModalService, private currentBusinessType: CurrentBusinessType) {
    this.modalService
      .getModalData()
      .pipe(take(1))
      .subscribe((res) => {
        this.modalData = res.modalData;
      });
  }
  ngOnInit(): void {
    this.businessType = this.currentBusinessType.getBusinessType();
  }
  closeModal(reason: any): void {
    this.modalService.closeDialog(reason);
  }
  getImageRendition(image: any) {
    let size: string;
    size = ShimanoUtilMethod.imageRendition(654);
    return ShimanoUtilMethod.newImageFormat(image, size);
  }
}
